<template>
  <div class="colorFondo">
    <v-container fluid class="white elevation-3 margen d-flex justify-space-around">
      <h1>Despiece</h1>
      <v-btn class="mt-2 success" small text to="/crearDespiece">Nuevo Despiece</v-btn>
    </v-container>
    
     <!-- <v-card class="ma-3">
     <v-text-field class="ma-3" v-model="buscador" label="Buscar" append-icon="mdi-magnifity" single-line></v-text-field>
     </v-card> -->

    <v-card class="ma-3">
      <v-row class="mx-3 mt-3">
        <v-btn class="success darken-1 mt-3 mx-auto" small text @click="obtenerDespiece()">Actualizar</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
        class="ma-3"
        v-model="buscador"
        label="Buscar"
        append-icon="mdi-magnify"
        single-line
        />
      </v-row>

     <v-data-table
     :headers="columnas"
     :items="despiece"
     :search="buscador"
     :loading="cargando"
     item-class="allB"
     >
     <template v-slot:[`item.ESTATUS`]="{item}">
       <div>
         {{estatus(item.ESTATUS)}}
       </div>
     </template>
       
        <template v-slot:[`item.actionEditar`]="{ item }">
        <div>
          <ModalEditar
          :infoDespiece ="item"
          @actualizarTabla ="obtenerDespiece"
          :key="item.DESPIECE_ID"/>
        </div>
      </template>
        
    
       <template v-slot:[`item.actionEliminar`]="{ item }">
        <div>
          <ModalEliminar
          :infoDespiece ="item"
          @actualizarTabla ="obtenerDespiece"
          :key="item.DESPIECE_ID"/>
        </div>
      </template>

     <template slot="no-data">
       <v-alert class="my-2" :value="true" type="info" color="orange darken-1">
         No se encontro informacion para mostrar
         </v-alert>
     </template>
     </v-data-table>
    </v-card>
  </div>
</template>

<script>
import ModalEditar from './Modals/ModalEditar'
import ModalEliminar from './Modals/ModalEliminar'
import axios from 'axios';
import {mapGetters} from 'vuex';

export default {
  components: { ModalEditar, ModalEliminar},

  data() {
    return {
     
     despiece:[],

     dialog: false,
     chosenFile:null,
     data: null,
     File:[],
     articulo: [],

     buscador:"",
     cargando:false,

     columnas:[
          {text:"Folio",                    value:"FOLIO"                 ,divider:true, class:'primary lighten-1 white--text'},
          {text:"Folio_MSP",                value:"FOLIO_MSP"             ,divider:true, class:'primary lighten-1 white--text'},
          {text:"Producto",                 value:"CLAVE_ARTICULO"           ,divider:true, class:'primary lighten-1 white--text'},
          {text:"Fecha Despiece",           value:"FECHA_DESPIECE"        ,divider:true, class:'primary lighten-1 white--text'},
          {text:"Estatus",                  value:"ESTATUS"               ,divider:true, class:'primary lighten-1 white--text'},
          {text:"Entrada de Almacen",       value:"ALMACEN_ENTRADA"       ,divider:true, class:'primary lighten-1 white--text'},
          {text:"Salida de Almacen",        value:"ALMACEN_SALIDA"        ,divider:true, class:'primary lighten-1 white--text'},
          {text:"Editar", sortable:false,   value:"actionEditar"          ,divider:true, class:'primary lighten-1 white--text'},
          {text:"Accion", sortable:false,   value:"actionEliminar"        ,divider:true, class:'primary lighten-1 white--text'},

     ],

    }
  },

  computed: {
    ...mapGetters(['getURLAPI', 'getFechaActual']),
  },

  methods: {
   
   async obtenerDespiece(){
      this.despiece=[];
      //this.articulo=[];
      this.cargando = true;
      this.despiece = (await axios.get(`${this.getURLAPI}/Despiece/mostrarDespiece`)).data
      console.log(this.despiece)
      this.cargando = false;
   },
      //----------------------------
      editarDespiece(despiece)
      {
        this.despiece = despiece;
        this.mostrarModal = true;
      },

      //-------------------------------------------
      claseItem(item)
      {
        if(!item) return
        return "mouse"
      },
      //--------------------------------------
      estatus(ESTATUS)
      {
        if(ESTATUS == 'A')
        {
          return 'Activo'
        }
          else if(ESTATUS == 'B')
          {
            return 'Baja'
          }
       
      },
    
  },

  created() {
    document.title = "Despiece | Bombas y Suministros del Norte";
    this.obtenerDespiece();
  },
}
</script>

<style>
@media screen and (max-width : 425px){
  #mobil{
    font-size: small;
    word-break: inherit!important;
  }
}
.mouse{
  cursor: pointer!important;
}
</style>